import $ from 'jquery';

import widgetFactory from '../widgetFactory';

const widgetName = 'textInput';
const KEY_ENTER = 13;

export default widgetFactory(widgetName, {
  options: {
    idleDelay: 2000,
    onChange: $.noop,
  },

  _create() {
    this._super(widgetName);

    this._timeoutHandler = null;
    this._val = this.element.val();

    this.element.on('blur', () => {
      clearTimeout(this._timeoutHandler);

      if (this._val !== this.element.val()) {
        this._handleChange();
      }
    });

    this.element.on('keyup', (event) => {
      clearTimeout(this._timeoutHandler);

      if (event.which === KEY_ENTER) {
        event.preventDefault();

        if (this._val !== this.element.val()) {
          this._handleChange();
        }

        return;
      }

      this._timeoutHandler = setTimeout(() => {
        this._handleChange();
      }, this.options.idleDelay);
    });
  },

  _handleChange() {
    this._val = this.element.val();
    this._trigger('onChange', event, { value: this.element.val() });
  },
});
